import { Link } from 'react-router-dom'
import { ArrowRight, ShoppingBag, Trash2 } from 'lucide-react'
import { formatarReais } from '@du/shared'
import { Button, Divider, EmptyState, Icone, QuantityStepper, SectionTitle } from '@du/ui'
import { useCarrinho } from '../lib/carrinho.js'
import { useCotacao } from '../lib/cotacao.js'

export function Carrinho() {
  const { itens, alterarQuantidade, remover, totalItens } = useCarrinho()
  // Retirada na cotação do carrinho: a taxa só entra quando a pessoa escolher
  // entrega e informar o bairro, no checkout. Mostrar taxa antes disso seria
  // prometer um valor que ainda pode mudar.
  const { cotacao, erro, carregando } = useCotacao(itens, { tipo: 'RETIRADA' })

  if (itens.length === 0) {
    return (
      <EmptyState
        icone={ShoppingBag}
        titulo="Seu carrinho está vazio"
        texto="Escolha um lanche e ele aparece aqui."
        acao={
          <Link to="/">
            <Button variante="secundario">Ver o cardápio</Button>
          </Link>
        }
      />
    )
  }

  return (
    <div className="bloco">
      <SectionTitle variante="laranja">Seu pedido</SectionTitle>

      <ul className="carrinho">
        {itens.map((i) => {
          const calculado = cotacao?.itens.find((c) => c.produtoId === i.produtoId)
          return (
            <li className="carrinho__item" key={i.linhaId}>
              {i.fotoUrl ? <img src={i.fotoUrl} alt="" className="carrinho__foto" loading="lazy" /> : null}
              <div className="carrinho__corpo">
                <strong>{i.nome}</strong>
                {i.adicionais.length > 0 ? (
                  <span className="carrinho__extra">
                    {i.adicionais.map((a) => `+ ${a.nome}`).join(' · ')}
                  </span>
                ) : null}
                {i.observacao ? <span className="carrinho__obs">{i.observacao}</span> : null}
                <QuantityStepper
                  valor={i.quantidade}
                  onMudar={(q) => alterarQuantidade(i.linhaId, q)}
                  min={0}
                />
              </div>
              <div className="carrinho__direita">
                <span className="carrinho__preco">
                  {calculado ? formatarReais(calculado.totalCents) : '—'}
                </span>
                <button
                  type="button"
                  className="carrinho__remover"
                  onClick={() => remover(i.linhaId)}
                  aria-label={`Remover ${i.nome}`}
                >
                  <Icone de={Trash2} tamanho={18} />
                </button>
              </div>
            </li>
          )
        })}
      </ul>

      <Divider />

      {erro ? (
        <p className="erro-faixa">{erro.message}</p>
      ) : (
        <div className="totais">
          <span>Subtotal ({totalItens} {totalItens === 1 ? 'item' : 'itens'})</span>
          <strong>{carregando ? '…' : cotacao ? formatarReais(cotacao.subtotalCents) : '—'}</strong>
        </div>
      )}
      <p className="totais__nota">A taxa de entrega aparece no próximo passo, depois do endereço.</p>

      <Link to="/checkout" className="bloco-acao">
        <Button
          tamanho="lg"
          larguraTotal
          iconeDireita={ArrowRight}
          disabled={!cotacao || Boolean(erro)}
        >
          Continuar
        </Button>
      </Link>
      <Link to="/" className="voltar">
        Adicionar mais itens
      </Link>
    </div>
  )
}
